import { AxiosRequestConfig } from 'axios'
import instance from './instance'
import { setupInterceptors } from './interceptors'

// 初始化拦截器（仅执行一次）
setupInterceptors(instance)

/**
 * 发起 GET 请求。
 * @param url     请求路径
 * @param params  URL 查询参数
 * @param config  额外的 axios 配置（可传入 signal 用于取消请求）
 */
export function get<T>(url: string, params?: object, config?: AxiosRequestConfig): Promise<T> {
  return instance.get<T, T>(url, { params, ...config })
}

/**
 * 发起 POST 请求。
 * @param url    请求路径
 * @param data   请求体数据
 * @param config 额外的 axios 配置（可传入 signal 用于取消请求）
 */
export function post<T>(url: string, data?: object, config?: AxiosRequestConfig): Promise<T> {
  return instance.post<T, T>(url, data, config)
}

/**
 * 发起 PUT 请求。
 * @param url    请求路径
 * @param data   请求体数据
 * @param config 额外的 axios 配置（可传入 signal 用于取消请求）
 */
export function put<T>(url: string, data?: object, config?: AxiosRequestConfig): Promise<T> {
  return instance.put<T, T>(url, data, config)
}

/**
 * 发起 DELETE 请求。
 * @param url    请求路径
 * @param params URL 查询参数
 * @param config 额外的 axios 配置（可传入 signal 用于取消请求）
 */
export function del<T>(url: string, params?: object, config?: AxiosRequestConfig): Promise<T> {
  return instance.delete<T, T>(url, { params, ...config })
}

/**
 * 发起 PATCH 请求。
 * @param url    请求路径
 * @param data   请求体数据
 * @param config 额外的 axios 配置（可传入 signal 用于取消请求）
 */
export function patch<T>(url: string, data?: object, config?: AxiosRequestConfig): Promise<T> {
  return instance.patch<T, T>(url, data, config)
}

export default instance
